const hardCodedRates =
  "{'EGP': '1','SAR': '0.074','AED': '0.072','QAR': '0.072','BHD': '0.0074', 'KWD': '0.0060'}";

export const EXCHANGE_RATES = JSON.parse(hardCodedRates?.replace(/'/g, '"') || '{}');

export interface Currency {
  code: string;
  flag: string;
  name: string;
}

export const currencies: Currency[] = [
  { code: 'EGP', flag: '🇪🇬', name: 'Egyptian Pound' },
  { code: 'SAR', flag: '🇸🇦', name: 'Saudi Riyal' },
  { code: 'AED', flag: '🇦🇪', name: 'UAE Dirham' },
  { code: 'QAR', flag: '🇶🇦', name: 'Qatar Riyal' },
  { code: 'BHD', flag: '🇧🇭', name: 'Bahraini Dinar' },
  { code: 'KWD', flag: '🇰🇼', name: 'Kuwaiti Dinar' },
];

export const currencyMap: Record<string, string> = {
  SA: 'SAR',
  AE: 'AED',
  QA: 'QAR',
  KW: 'KWD',
  BH: 'BHD',
  EG: 'EGP',
};

export type CurrencyCode = Currency['code'];

// Currency conversion utilities
export function convertToEGP(amount: number, fromCurrency: CurrencyCode): number {
  if (fromCurrency === 'EGP') return amount;

  const rate = EXCHANGE_RATES[fromCurrency];
  if (!rate) {
    console.warn(`Exchange rate not found for ${fromCurrency}, using 1:1`);
    return amount;
  }

  // Convert from user currency to EGP and round to whole number
  // If 1 SAR = 0.074 EGP, then to convert SAR to EGP: amount / 0.074
  return Math.round(amount / parseFloat(rate));
}

export function convertFromEGP(amount: number, toCurrency: CurrencyCode): number {
  if (toCurrency === 'EGP') return amount;

  const rate = EXCHANGE_RATES[toCurrency];
  if (!rate) {
    console.warn(`Exchange rate not found for ${toCurrency}, using 1:1`);
    return amount;
  }

  // Convert from EGP to user currency and round to whole number
  // If 1 SAR = 0.074 EGP, then to convert EGP to SAR: amount * 0.074
  return Math.round(amount * parseFloat(rate));
}

export function formatCurrency(amount: number, currency: CurrencyCode): string {
  const convertedAmount = convertFromEGP(amount, currency);

  // Format based on currency - all currencies use whole numbers
  switch (currency) {
    case 'EGP':
      return `EGP ${convertedAmount.toLocaleString('en-EG', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    case 'SAR':
      return `SAR ${convertedAmount.toLocaleString('en-SA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    case 'AED':
      return `AED ${convertedAmount.toLocaleString('en-AE', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    case 'QAR':
      return `QAR ${convertedAmount.toLocaleString('en-QA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    case 'BHD':
      return `BHD ${convertedAmount.toLocaleString('en-BH', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    case 'KWD':
      return `KWD ${convertedAmount.toLocaleString('en-KW', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    default:
      return `${currency} ${convertedAmount.toLocaleString()}`;
  }
}
